'use client';

import { Loader2 } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { CustomerField } from '@/components/customer-surface/CustomerForm';
import { cn } from '@/components/ui/utils';

export function LoyaltyIdentifyForm({
  phoneNumber,
  onPhoneNumberChange,
  onSubmit,
  onPasskeySignIn,
  error,
  loading,
  passkeyBusy,
}: {
  phoneNumber: string;
  onPhoneNumberChange: (value: string) => void;
  onSubmit: () => void;
  onPasskeySignIn: () => void;
  error?: string | null;
  loading?: boolean;
  passkeyBusy?: boolean;
}) {
  return (
    <div className="cs-card space-y-5">
      <p className="cs-label">Check your points</p>
      <p className="cs-body-sm text-[var(--cs-text-secondary)]">
        No account, no password. Your phone number is enough, or use a passkey if you've set one up here before.
      </p>

      <Button
        type="button"
        variant="outline"
        className="cs-focusable min-h-[var(--cs-touch-rec)] w-full"
        disabled={passkeyBusy || loading}
        onClick={onPasskeySignIn}
      >
        {passkeyBusy ? (
          <Loader2 className="mr-1.5 size-4 animate-spin" />
        ) : null}
        {passkeyBusy ? 'Checking...' : 'Recognise me with a passkey'}
      </Button>

      <div className="flex items-center gap-3">
        <span className="h-px flex-1 bg-[var(--cs-border)]" />
        <span className="cs-caption uppercase tracking-[0.14em] text-[var(--cs-text-muted)]">or</span>
        <span className="h-px flex-1 bg-[var(--cs-border)]" />
      </div>

      <CustomerField
        label="Phone number"
        type="tel"
        inputMode="tel"
        autoComplete="tel"
        value={phoneNumber}
        onChange={(event) => onPhoneNumberChange(event.target.value)}
        onKeyDown={(event) => {
          if (event.key === 'Enter') {
            event.preventDefault();
            onSubmit();
          }
        }}
        placeholder="024 000 0000"
        error={error}
        hint="The number you gave when you last ordered here."
      />

      <Button
        type="button"
        className="cs-focusable min-h-[var(--cs-touch-rec)] w-full"
        disabled={loading || !phoneNumber.trim()}
        onClick={onSubmit}
      >
        {loading ? <Loader2 className="mr-1.5 size-4 animate-spin" /> : null}
        {loading ? 'Looking you up...' : 'Check my points'}
      </Button>
    </div>
  );
}
